define(["require", "exports"], function (require, exports) {
    "use strict";
    var _a;
    exports.__esModule = true;
    exports.defaultDesign = (_a = {
            title: 'Custom curtain design',
            designCode: null
        },
        _a['for'] = {
            name: 'client'
        },
        _a.by = {
            name: 'designer',
            webSite: ''
        },
        _a.images = [],
        _a.notes = '',
        _a.fabric = null,
        _a.style = null,
        _a.size = null,
        _a.product = null,
        _a.fringe = 'N/A',
        _a);
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/designbook.models.js
// module id = 49
// module chunks = 0